import { fetcher } from "../../utils/fetcher.js";

export const dismissSystemBanner = (id) =>
  fetcher.post(`/api/system-banners/${id}/dismiss`);
